import { useState, useEffect } from 'react';

import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
} from "@stripe/react-stripe-js";

import { useBillingHook } from '../../../Hooks/Billings/billingHooks';

import { CheckoutBillingInfoInterface } from '../../../Models/Common/CustomViewsInterfaces';

import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';
import LocalStorageHelper from '../../../Utilities/Helpers/LocalStorageHelper';

import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';

import { GlobalSettingsConstants } from '../../../Constants/GlobalConstants';

import CustomStepContent from '../../../CustomViews/Elements/CustomStepper/CustomStepContent';
import StripeForm from './StripeForm';

export default function PaymentInfo(props: CheckoutBillingInfoInterface) {
    let isDarkMode = LocalStorageHelper.isDarkMode();
    let stripePromise: any = loadStripe(GlobalSettingsConstants.STRIPE_PUBLISHABLE_KEY ?? "", {
        developerTools: {
            assistant: {
                enabled: false,
            },
        },
    });

    //Use States
    const [queryStr, setQueryStr] = useState({
        pageSize: 10,
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
    });

    const q_queryKey = [CachingEnum.BILLINGS, queryStr];
    const { DropdownData, dropdownFetchStatus } = useBillingHook(q_queryKey, queryStr, false);

    //Variables
    
    //Event Handlers
    
    //Rendering Functions
    return <CustomStepContent
        stepHeader={"Payment Selection"}
        stepSubHeader={"Please select and enter your billing information"}
        children={<>
            <Elements stripe={stripePromise} options={{
                clientSecret: props.stripeKey,
                appearance: { theme: isDarkMode ? "night" : "stripe" },
            }}>
                <StripeForm {...props} stepperItems={DropdownData[CachingEnum.CHECKOUT_STEP_LIST] ?? []} />
            </Elements>
        </>}
        stepperItems={DropdownData[CachingEnum.CHECKOUT_STEP_LIST] ?? []}
        selectedStep={props?.selectedStep}
        setselectedStep={props?.setselectedStep}
        hideprevStep={true}
        hidenextStep={true} />
}
